/*
 * IMPORTS
 */
import { gql } from "@apollo/client"; // NPM: Apollo client for handling graphql request.

/*
 * GRAPH
 */
const Index = gql`
  mutation MyMutation($developerAccountId: ID!) {
    ApproveDeveloperAccount(developerAccountId: $developerAccountId) {
      status
      message
    }
  }
`;

/*
 * EXPORTS
 */
export default Index;
